
import * as dom from './../../modules/wpstg-dom-utils.js';

export default class WpstgRemoteStorage {
  constructor(
      revokeButtonSelector = '#wpstg-btn-provider-revoke',
      revokeProviderFormSelector = '#wpstg-provider-revoke-form',
      revokeAction = 'wpstg-provider-revoke',
      settingsButtonSelector = '#wpstg-btn-save-provider-settings',
      settingsFormSelector = '#wpstg-provider-settings-form',
      settingsAction = 'wpstg-provider-settings',
      authenticateButtonSelector = '#wpstg-btn-provider-authenticate',
      authenticateFormSelector = '#wpstg-provider-authenticate-form',
      authenticateAction = 'wpstg-provider-authenticate',
      testConnectionButtonSelector = '#wpstg-btn-provider-test-connection',
      testConnectionFieldsSelector = '#wpstg-provider-test-connection-fields',
      testConnectionAction = 'wpstg-provider-test-connection',
      wpstgObject = wpstg,
  ) {
    this.revokeButtonSelector = revokeButtonSelector;
    this.revokeForm = dom.qs(revokeProviderFormSelector);
    this.revokeAction = revokeAction;
    this.settingsButtonSelector = settingsButtonSelector;
    this.settingsForm = dom.qs(settingsFormSelector);
    this.settingsAction = settingsAction;
    this.authenticateButtonSelector = authenticateButtonSelector;
    this.authenticateForm = dom.qs(authenticateFormSelector);
    this.authenticateAction = authenticateAction;
    this.testConnectionButtonSelector = testConnectionButtonSelector;
    this.testConnectionFields = dom.qs(testConnectionFieldsSelector);
    this.testConnectionAction = testConnectionAction;
    this.wpstgObject = wpstgObject;
    this.notyf = new Notyf({
      duration: 2000,
      position: {
        x: 'center',
        y: 'bottom',
      },
      dismissible: true,
    });
    this.init();
  }

  addEvents() {
    dom.addEvent(document.body, 'click', this.revokeButtonSelector, async (target) => {
      await this.sendRevokeRequest();
    });

    dom.addEvent(document.body, 'click', this.settingsButtonSelector, async (target) => {
      await this.sendSettingsRequest();
    });

    dom.addEvent(document.body, 'click', this.authenticateButtonSelector, async (target) => {
      await this.sendAuthenticateRequest();
    });

    dom.addEvent(document.body, 'click', this.testConnectionButtonSelector, async (target) => {
      await this.sendTestConnectionRequest();
    });

    dom.addEvent(document.body, 'change', '[name=\'ftp_type\']', async (target) => {
      await this.toggleSftpFields();
    });
  }

  init() {
    this.addEvents();
  }

  async sendRevokeRequest() {
    const provider = this.revokeForm.querySelector('input[name="provider"]').value;
    try {
      const response = await fetch(this.wpstgObject.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        body: new URLSearchParams({
          action: this.revokeAction,
          accessToken: this.wpstgObject.accessToken,
          nonce: this.wpstgObject.nonce,
          provider: provider,
        }),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      if (!response.ok) {
        console.error(`An error has occured: ${response.status}`);
      }

      const data = await response.json();

      if (data.success) {
        this.notyf.success(data.message);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
        return;
      }

      this.notyf.error(data.message);
    } catch (error) {
      console.warn(error);
    }
  }

  async sendSettingsRequest() {
    const formData = new FormData(this.settingsForm);
    formData.append('action', this.settingsAction);
    formData.append('accessToken', this.wpstgObject.accessToken);
    formData.append('nonce', this.wpstgObject.nonce);

    const queryString = new URLSearchParams(formData);
    try {
      const response = await fetch(this.wpstgObject.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        body: queryString,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      if (!response.ok) {
        console.error(`An error has occured: ${response.status}`);
      }

      const data = await response.json();

      if (data.success) {
        this.notyf.success(data.message);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
        return;
      }

      this.notyf.error(data.message);
    } catch (error) {
      console.warn(error);
    }
  }

  async sendAuthenticateRequest() {
    const formData = new FormData(this.authenticateForm);
    formData.append('action', this.authenticateAction);
    formData.append('accessToken', this.wpstgObject.accessToken);
    formData.append('nonce', this.wpstgObject.nonce);
    const queryString = new URLSearchParams(formData);
    try {
      const response = await fetch(this.wpstgObject.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        body: queryString,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      if (!response.ok) {
        console.error(`An error has occured: ${response.status}`);
      }

      const data = await response.json();

      if (data.success) {
        this.notyf.success(data.message);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
        return;
      }

      this.notyf.error(data.message);
    } catch (error) {
      console.warn(error);
    }
  }

  async sendTestConnectionRequest() {
    const fields = this.testConnectionFields.querySelectorAll('[name]');
    const formData = new FormData();
    formData.append('action', this.testConnectionAction);
    formData.append('accessToken', this.wpstgObject.accessToken);
    formData.append('nonce', this.wpstgObject.nonce);
    fields.forEach((element) => {
      formData.append(element.getAttribute('name'), element.value);
    });

    const queryString = new URLSearchParams(formData);
    try {
      const response = await fetch(this.wpstgObject.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        body: queryString,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      if (!response.ok) {
        console.error(`An error has occured: ${response.status}`);
      }

      const data = await response.json();

      if (data.success) {
        this.notyf.success(data.message);
        return;
      }

      this.notyf.error(data.message);
    } catch (error) {
      console.warn(error);
    }
  }

  toggleSftpFields() {
    const ftpType = document.querySelector('[name=\'ftp_type\']');
    const sftpElements = document.querySelectorAll('.only-sftp');
    const ftpElements = document.querySelectorAll('.only-ftp');
    if (ftpType.value === 'ftp') {
      if (sftpElements.length) {
        for (const el of sftpElements) {
          el.classList.add('hidden');
        }
      }

      if (ftpElements.length) {
        for (const el of ftpElements) {
          el.classList.remove('hidden');
        }
      }

      return;
    }

    if (sftpElements.length) {
      for (const el of sftpElements) {
        el.classList.remove('hidden');
      }
    }

    if (ftpElements.length) {
      for (const el of ftpElements) {
        el.classList.add('hidden');
      }
    }
  }
}
